// Einmalige Umstellung von SecureLS auf normalen localStorage.
//
// SecureLS (Base64, ohne Kompression) hat den Vuex-Stand als Base64 eines
// JSON-kodierten Strings gespeichert. Hier wird er beim ersten Laden der neuen
// Version zurückgewandelt, damit niemand abgemeldet wird.
// Kann entfernt werden, sobald alle Nutzer die neue Version einmal geladen haben.

const SECURE_LS_META_KEY = '_secure__ls__metadata';

// UTF-8-Dekodierung exakt wie in secure-ls (Base64._utf8Decode), damit auch
// Umlaute und Emojis (von secure-ls als einzelne Surrogate kodiert) erhalten bleiben
function utf8Decode(bytes) {
  let out = '';
  let i = 0;
  while (i < bytes.length) {
    const c = bytes.charCodeAt(i);
    if (c < 128) {
      out += String.fromCharCode(c);
      i += 1;
    } else if (c > 191 && c < 224) {
      out += String.fromCharCode(((c & 31) << 6) | (bytes.charCodeAt(i + 1) & 63));
      i += 2;
    } else {
      out += String.fromCharCode(
        ((c & 15) << 12) | ((bytes.charCodeAt(i + 1) & 63) << 6) | (bytes.charCodeAt(i + 2) & 63)
      );
      i += 3;
    }
  }
  return out;
}

export function migrateSecureLsState(storage, key) {
  try {
    const raw = storage.getItem(key);
    if (raw) {
      try {
        JSON.parse(raw); // schon Klartext-JSON → bereits umgestellt
      } catch (notJson) {
        try {
          const decoded = JSON.parse(utf8Decode(atob(raw.replace(/[^A-Za-z0-9+/=]/g, ''))));
          const state = typeof decoded === 'string' ? decoded : JSON.stringify(decoded);
          JSON.parse(state);
          storage.setItem(key, state);
        } catch (unreadable) {
          storage.removeItem(key);
        }
      }
    }
    storage.removeItem(SECURE_LS_META_KEY);
  } catch (storageError) {
    // localStorage nicht verfügbar (z. B. gesperrt) – nichts zu migrieren
  }
}
